import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Header from "../Header"
import "./index.less";
import img1 from "@/assets/images/img1.png";
import img2 from "@/assets/images/img2.png";
import { Modal } from "antd";

const Frame = (props) => {
  const loadtion = useLocation();
  const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
  
  // 选中的菜单
  useEffect(() => {
    console.log(loadtion);
    window.scrollTo(0, 0);
  }, [loadtion]);
    const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const goUrl = ()=>{
    window.location.href="https://www.rwadeai.com/"
  }
  return (
    <div className="page">
      <Header/>
      <div>{props.children}</div>
         <Modal title={""} centered open={isModalOpen} onOk={handleOk} closable={false} keyboard={false} maskClosable={false} onCancel={handleCancel} footer={null}>
              <div class="tips_box_new">
                  <div className="tit">因品牌升级需要，我们已经进行了域名迁移，本域名于8.15日停止服务，请访问最新链接。</div>
                  <div className="url" onClick={goUrl}>www.rwadeai.com</div>
              </div>
            </Modal>
    </div>
  );
};
export default Frame;
